export const TOOL_NAME = 'Add Group';

export const CREATE_GROUP_TASK = 'create-group';
export const CREATE_GROUP_REQUEST_MESSAGE = 'Creating group in progress...';
